import EmptyList from '@ifca-root/react-component/src/components/CardList/EmptyList'
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  styled,
} from '@material-ui/core'
import { amtStr } from 'helpers/StringNumberFunction/NumFormatters'
import { default as React, useEffect, useMemo } from 'react'
import { Controller } from 'react-hook-form'
import { Autocomplete } from '@material-ui/lab'
import { AccCodeDropdownFullWidth } from 'components/Dropdown/AccCodeDropdown'
import {
  useGetEntityCoaQuery,
  useGetMasterCoaCodeQuery,
} from 'generated/graphql'
import { dateFormat } from 'helpers/StringNumberFunction/FormatDate'
import { SystemMsgs } from 'helpers/Messages/SystemMsg'

export const InvoiceAmortisationItemForm = (props: any) => {
  const {
    listItem,
    control,
    index,
    x,
    register,
    CompanyID,
    setErrMessage,
    setErrDialog,
    editData,
    setValue,
    errors,
    watch,
    mode,
    isErrorCall,
  } = props

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(even)': {
      backgroundColor: '#fff4dc',
    },
    '&:last-child td, &:last-child th': {
      border: 0,
    },
  }))

  /* -------------------------------------------- */
  /*                    API                       */
  /* -------------------------------------------- */

  const {
    loading: MasterCOALoading,
    data: { getMasterCOA } = { getMasterCOA: [] },
  } = useGetMasterCoaCodeQuery({
    fetchPolicy: 'network-only',
    variables: { IsLastNode: true },
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
  })
  const {
    loading: EntityCOALoading,
    data: { getEntityCOA } = { getEntityCOA: [] },
  } = useGetEntityCoaQuery({
    fetchPolicy: 'network-only',
    variables: { CompanyID },
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
  })
  const masterCOAList = useMemo(() => {
    const coaList =
      getEntityCOA?.length > 0
        ? getEntityCOA
            ?.map(coa => coa?.MasterCOA)
            ?.filter(
              coa => coa?.IsLastNode === true && coa?.IsControl === false
            )
        : getMasterCOA?.filter(
            coa => coa?.IsLastNode === true && coa?.IsControl === false
          )

    const uniqueCOA = Array.from(
      new Map(coaList?.map(coa => [coa?.MasterCOAID, coa])).values()
    )

    return uniqueCOA
  }, [getEntityCOA, getMasterCOA])

  const totalAmount = listItem.reduce((sum, row) => sum + (row?.Amount || 0), 0)

  useEffect(() => {
    if (editData && masterCOAList?.length > 0 && x?.InvoiceItemID) {
      const matchingItem = editData.AmortisationItem?.find(
        item => item.InvoiceItemID === x.InvoiceItemID
      )
      if (matchingItem) {
        const coaId =
          matchingItem?.MasterCOA?.MasterCOAID ||
          matchingItem?.creditMasterCoaID
        if (coaId) {
          setValue(`InvoiceAmortisationItem.${index}.MasterCOAID`, coaId)
        }
      }
    }
  }, [editData, setValue, masterCOAList, x?.InvoiceItemID, index])

  return (
    <>
      {!EntityCOALoading && !MasterCOALoading && (
        <Controller
          control={control}
          name={`InvoiceAmortisationItem.${index}.MasterCOAID`}
          ref={register}
          defaultValue={
            editData?.AmortisationItem?.find(
              item => item.InvoiceItemID === x?.InvoiceItemID
            )?.creditMasterCoaID || ''
          }
          render={({ onChange, onBlur, value }) => {
            const selectedCOA = masterCOAList?.find(
              coa => coa?.MasterCOAID === value
            )

            return (
              <Autocomplete
                className="controllerStyle"
                style={{ placeContent: 'center' }}
                options={
                  masterCOAList?.sort((a, b) => {
                    return a.Code.localeCompare(b.Code)
                  }) || []
                }
                getOptionLabel={option => `${option?.Code} | ${option?.Name}`}
                value={selectedCOA || null}
                fullWidth
                renderOption={(option, props) => (
                  <>
                    <div>
                      <div>
                        <span className="xsTitle">{option?.Code}</span>
                      </div>
                      <div className="desc">{option?.Name}</div>
                    </div>
                  </>
                )}
                onChange={(event, newValue: any) => {
                  onChange(newValue?.MasterCOAID || '')
                }}
                PopperComponent={AccCodeDropdownFullWidth}
                renderInput={(params: any) => {
                  return (
                    <TextField
                      {...params}
                      className="fieldstyle"
                      InputLabelProps={{ shrink: true }}
                      label="GL Account Code"
                      required
                      variant="outlined"
                      helperText={
                        isErrorCall === true &&
                        ['', null, undefined].includes(value)
                          ? SystemMsgs.accountCode()
                          : ''
                      }
                      error={
                        isErrorCall === true &&
                        ['', null, undefined].includes(value)
                      }
                    />
                  )
                }}
              />
            )
          }}
          helperText={
            isErrorCall === true &&
            ['', null, undefined].includes(
              watch(`InvoiceAmortisationItem.${index}.MasterCOAID`)
            )
              ? SystemMsgs.accountCode()
              : ''
          }
          error={
            isErrorCall === true &&
            ['', null, undefined].includes(
              watch(`InvoiceAmortisationItem.${index}.MasterCOAID`)
            )
              ? true
              : false
          }
        />
      )}

      <div style={{ paddingBottom: '50px' }} />
      <TableContainer component={Paper}>
        <Table aria-label="simple table">
          <TableHead>
            {listItem?.length <= 0 ? (
              <EmptyList
                title="No Record found"
                subtitle="Add a new record now."
              />
            ) : (
              <TableRow>
                <TableCell
                  className="StyledTableCell"
                  style={{ fontSize: '11px', color: 'white' }}
                  align="center"
                >
                  Fyear
                </TableCell>
                <TableCell
                  className="StyledTableCell"
                  style={{ fontSize: '11px', color: 'white' }}
                  align="center"
                >
                  Fperiod
                </TableCell>
                <TableCell
                  className="StyledTableCell"
                  style={{ fontSize: '11px', color: 'white' }}
                  align="center"
                >
                  Amort Date
                </TableCell>
                <TableCell
                  className="StyledTableCell"
                  style={{ fontSize: '11px', color: 'white' }}
                  align="center"
                >
                  Amount
                </TableCell>
              </TableRow>
            )}
          </TableHead>
          <TableBody>
            {listItem.map((row, index) => {
              return (
                <>
                  <TableRow component={StyledTableRow}>
                    <TableCell style={{ fontSize: '11px' }} align="center">
                      {row?.FYear}
                    </TableCell>
                    <TableCell style={{ fontSize: '11px' }} align="center">
                      {row?.FPeriod}
                    </TableCell>
                    <TableCell style={{ fontSize: '11px' }} align="center">
                      {dateFormat(row?.AmortDate)}
                    </TableCell>
                    <TableCell style={{ fontSize: '11px' }} align="center">
                      {amtStr(row?.Amount)}
                    </TableCell>
                  </TableRow>
                </>
              )
            })}

            {listItem.length > 0 && (
              <TableRow component={StyledTableRow}>
                <TableCell
                  style={{ fontSize: '11px', fontWeight: 'bold' }}
                  align="center"
                >
                  Total
                </TableCell>
                <TableCell
                  style={{ fontSize: '11px' }}
                  align="center"
                ></TableCell>
                <TableCell
                  style={{ fontSize: '11px' }}
                  align="center"
                ></TableCell>
                <TableCell
                  style={{ fontSize: '11px', fontWeight: 'bold' }}
                  align="center"
                >
                  {amtStr(totalAmount)}
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  )
}
